import styles from "./FormSectionTitle.module.scss";

export const FormSectionTitle = ({ title }) => {
    return <h3 className={styles["root"]}>{title}</h3>;
};
